import { createRoute } from '@tanstack/react-router'
import { useAuthStore } from '@/application/stores/auth.store'
import { investigationsRoute } from '@/ui/pages/management/investigations'
import { InvestigationsListSection } from './components/InvestigationsListSection'

// ──────────────────────────────────────────────
// Route — /manage/investigations (index)
// ──────────────────────────────────────────────
export const investigationsIndexRoute = createRoute({
  getParentRoute: () => investigationsRoute,
  path: '/',
  validateSearch: (search: Record<string, unknown>) => {
    const rawFilter = search.statusFilter
    const statusFilter: 'active' | 'inactive' | 'pending' | 'suggestions' =
      rawFilter === 'active' ||
      rawFilter === 'inactive' ||
      rawFilter === 'pending' ||
      rawFilter === 'suggestions'
        ? rawFilter
        : 'active'
    const category =
      typeof search.category === 'string' && search.category !== '' ? search.category : undefined
    return category ? { statusFilter, category } : { statusFilter }
  },
  component: InvestigationsIndexPage,
})

// ──────────────────────────────────────────────
// Page composition
// ──────────────────────────────────────────────
export function InvestigationsIndexPage() {
  const { user } = useAuthStore()
  const isPrivileged =
    user?.role === 'streamer' || user?.role === 'moderator' || user?.role === 'admin'
  const { statusFilter, category } = investigationsIndexRoute.useSearch()

  return (
    <div className="space-y-6">
      <InvestigationsListSection
        isPrivileged={isPrivileged}
        statusFilter={statusFilter}
        category={category}
      />
    </div>
  )
}
